import { Box, Card, Flex, Grid, Text } from '@mantine/core';
import rasterizeHTML from 'rasterizehtml';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

const EmailPreviewCard = ({ email }) => {
  const canvas = useRef();

  const location = useLocation();

  useEffect(() => {
    rasterizeHTML.drawHTML(email.html, canvas.current);
  }, [email.html]);

  return (
    <>
      <Card withBorder>
        <Card.Section inheritPadding py="sm">
          <Grid>
            <Grid.Col span={{ base: 12, md: 3 }}>
              <Flex direction="column" justify="center" mb="lg">
                <Text size="sm" c="dimmed">Email Name:</Text>
                <a style={{ textAlign: 'left' }} href={`#${location.pathname}/${email.id}/details`}>
                  <strong>{email.name}</strong>
                </a>
              </Flex>
            </Grid.Col>
            <Grid.Col span={{ base: 12, md: 9 }}>
              <canvas width="800" height="600" ref={canvas}></canvas>
            </Grid.Col>
          </Grid>
        </Card.Section>
      </Card>
    </>
  );
};

export default EmailPreviewCard;
